export default __webpack_public_path__ + "static/media/heart.8c7abc89.png";